import { useQueryWithBoundary } from '@/shared/lib/query';
import { qualityKeys } from '@/shared/lib/query/queryKeys';

import { getStatsTables, type StatsTablesApiParams } from '@/entities/quality/api/getStatsTables';

export const useStatsTablesQuery = (params: StatsTablesApiParams) => {
  return useQueryWithBoundary({
    queryKey: qualityKeys.statsTables(params),
    queryFn: () => getStatsTables(params),
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
};
